import styled from 'styled-components';

export const DescriptionDetails = styled('dd')`
  margin: 0;
`;

export const FadedNil = styled('span')<{
  value: string | number | null | undefined;
}>`
  ${({ value }) => (value === null || value === undefined) && 'opacity: 0.3'}
`;
